/* Paths.ts */

export enum Paths {
  HOME = "/",

  // AI Assistant
  AI_ASSISTANT = "/assistant",

  // Insights
  INSIGHTS = "/insights",
  DESCRIPTIVE_STATISTICS = "/descriptive-statistics",
  SURVIVAL_ANALYSIS = "/survival-analysis",
  TREATMENT_PATTERNS = "/treatment-patterns",

  // User Menu
  HELP_SUPPORT = "/help-support",
  GLOSSARY = "/glossary",
  IMPRINT = "/imprint",

  // Admin Dashboard
  ADMIN_DASHBOARD = "/admin-dashboard",
  DATA_HANDLER = "/data-handler",
  FEATURE_SELECTION = "/feature-selection",
  SETTINGS = "/settings",
}
